import { Directive, OnInit, ElementRef } from '@angular/core';

@Directive({
  selector: '[cbaAutofocus]'
})
export class AutofocusDirective implements OnInit {

  constructor(private elementRef: ElementRef) { };

  ngOnInit(): void {
    this.elementRef.nativeElement.focus();
  }

}


// WEBPACK FOOTER //
// ./src/app/custom/autofocus.directive.ts